module.exports = __webpack_public_path__ + "img/65.59d85046.jpg";